import { useState, useEffect } from 'react';
import { Marker, useMap } from 'react-map-gl';
import arrowIcon1 from '../assets/arrow-up-type-1.png';
import arrowIcon2 from '../assets/arrow-up-type-2.png';
import arrowIcon3 from '../assets/arrow-up-type-3.png';

const arrowIcons = { 1: arrowIcon1, 2: arrowIcon2, 3: arrowIcon3 };

const ThumbMarkerLayer = ({ item, onMarkerClick, passThrough }) => {
  const coords = item?.geometry?.coordinates;
  const { current: map } = useMap();
  const [bearing, setBearing] = useState(() => map?.getBearing?.() ?? 0);

  useEffect(() => {
    if (!map) return;
    const m = map.getMap ? map.getMap() : map;
    const update = () => setBearing(m.getBearing());
    m.on('rotate', update);
    m.on('rotateend', update);
    return () => {
      m.off('rotate', update);
      m.off('rotateend', update);
    };
  }, [map]);

  if (!coords || coords.length < 2) return null;

  const mediatype = item.properties?.mediatype || 1;
  const angle = item.properties?.angle || 0;
  const icon = arrowIcons[mediatype] || arrowIcon1;
  // Screen-clockwise rotation needed to make the arrow point at compass-`angle`
  // regardless of the map's bearing. CSS rotate() is viewport-relative, so we
  // subtract bearing to compensate.
  const screenRotation = angle - bearing;

  return (
    <Marker
      longitude={coords[0]}
      latitude={coords[1]}
      anchor="center"
      style={{ zIndex: 1, pointerEvents: passThrough ? 'none' : 'auto' }}
    >
      <img
        src={icon}
        alt=""
        onClick={(e) => {
          if (passThrough) return;
          e.stopPropagation();
          onMarkerClick && onMarkerClick(item);
        }}
        onMouseDown={(e) => { if (!passThrough) e.stopPropagation(); }}
        style={{
          width: '36px',
          height: '36px',
          transform: `rotate(${screenRotation}deg)`,
          borderRadius: '50%',
          outline: '3px solid white',
          boxShadow: '0 0 6px rgba(0,0,0,0.4)',
          cursor: passThrough ? 'crosshair' : (onMarkerClick ? 'pointer' : 'default'),
          filter: 'hue-rotate(120deg) saturate(2) brightness(0.75)',
          pointerEvents: passThrough ? 'none' : 'auto',
        }}
      />
    </Marker>
  );
};

export default ThumbMarkerLayer;
